// SolyticsTypography.jsx
// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography as MuiTypography } from '@mui/material';

// Default props as constants
const DEFAULT_VARIANT = 'body1';
const DEFAULT_COMPONENT = undefined; // MUI will auto-determine based on variant
const DEFAULT_ALIGN = 'inherit';
const DEFAULT_COLOR = 'text.primary';
const DEFAULT_GUTTER_BOTTOM = false;
const DEFAULT_NO_WRAP = false;
const DEFAULT_PARAGRAPH = false;

/**
 * SolyticsTypography - A wrapper around MUI Typography component
 *
 * Used to present design and content clearly and efficiently.
 * Supports various text styles defined in the theme.
 *
 * @component
 * @example
 * // Heading
 * <SolyticsTypography variant="h1">Main Heading</SolyticsTypography>
 *
 * @example
 * // Body text with custom styling
 * <SolyticsTypography
 *   variant="body1"
 *   color="text.secondary"
 *   mb={2}
 * >
 *   Paragraph text
 * </SolyticsTypography>
 *
 * @example
 * // Custom component
 * <SolyticsTypography variant="h6" component="h2">
 *   Semantic heading
 * </SolyticsTypography>
 */
const SolyticsTypography = React.forwardRef(function SolyticsTypography(
  {
    children,
    variant = DEFAULT_VARIANT,
    component = DEFAULT_COMPONENT,
    align = DEFAULT_ALIGN,
    color = DEFAULT_COLOR,
    gutterBottom = DEFAULT_GUTTER_BOTTOM,
    noWrap = DEFAULT_NO_WRAP,
    paragraph = DEFAULT_PARAGRAPH,
    ellipsis = false,
    href,
    target,
    rel,
    onClick,
    type,
  },
  ref
) {
  const typography = (
    <MuiTypography
      ref={ref}
      variant={variant}
      {...(component ? { component } : {})}
      align={align}
      color={color}
      gutterBottom={gutterBottom}
      noWrap={noWrap}
      paragraph={paragraph}
      {...(href !== undefined && { href })}
      {...(target !== undefined && { target })}
      {...(rel !== undefined && { rel })}
      {...(onClick !== undefined && { onClick })}
      {...(type !== undefined && { type })}
      sx={{
        ...(component === 'a' && {
          cursor: 'pointer',
          '&:hover': { textDecoration: 'underline' },
        }),
        ...(ellipsis && {
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
        }),
      }}
      title={ellipsis ? children : undefined} // Native tooltip as fallback when not using SolyticsTooltip
    >
      {children}
    </MuiTypography>
  );

  return typography;
});

export default SolyticsTypography;
